import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "../../../../components/Button/Button";
import InputField from "../../../../components/InputField/InputField";
import "./AddMentorStyle.css";
import Congratulations from "../../../../components/Popups/Congratulations/Congratulations";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addUser,
  adminData,
  clearState,
  clearUsers,
  getAllPrograms,
  getInterestsByProgram,
} from "../../../../reducer/adminSlice";
import ErrorToast from "../../../../components/Toast/ErrorToast";
import PageLoader from "../../../../components/loaders/PageLoader/PageLoader";
import { MultiSelect } from "react-multi-select-component";
import { TagsInput } from "react-tag-input-component";
import ToggleSwitch from "../../../../components/ToggleSwitch/ToggleSwitch";
import * as filestack from 'filestack-js';

const AddMentor = () => {

  const template = {
    profileImg: "",
    firstName: "",
    lastName: "",
    designation: "",
    company: "",
    mobileNumber: "",
    email: "",
    linkedIn: "",
    programs: "",
    interests: [],
    topics: [],
    yrsOfExp: "",
    about: "",
    languages: [],
    isAlumni: false
  };

  const errorTemplate = {
    firstName: "",
    // designation: "",
    // company: "",
    programs: "",
    email: "",
    mobileNumber: "",
    linkedIn: "",
    interests: "",
    topics: "",
    // yrsOfExp: "",
  };

  //Data states
  const [addMentor, setAddMentor] = useState(template);
  const [topicOptions, setTopicOptions] = useState([]);
  const [topics, setTopics] = useState([]);
  const [interestOptions, setInterestOptions] = useState([]);
  const [interests, setInterests] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [programOptions, setProgramOptions] = useState([]);

  //Error states
  const [errorAddMentor, setErrorAddMentor] = useState(errorTemplate);

  //Toast states
  const [isShowError, setIsShowError] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [isShowSuccess, setIsShowSuccess] = useState(false);

  //Loading states
  const [isLoading, setIsLoading] = useState(false);
  console.log(addMentor)
  const {
    isFetching,
    isProgramFetching,
    isUserAddedSuccess,
    isError,
    errorMessage,
    allPrograms,
    interestTopics,
  } = useSelector(adminData);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [searchParams] = useSearchParams();
  // const proId = searchParams.get("id");

  const handleChange = (e) => {
    setErrorAddMentor(errorTemplate);
    const { name, value } = e.target;
    if (name === "mobileNumber" && (value?.length > 10 || value < 0)) return;
    setAddMentor((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = () => {
    if (addMentor?.isAlumni) {
      setAddMentor(prev => ({
        ...prev,
        isAlumni: false
      }));
    }
    else {
      setAddMentor(prev => ({
        ...prev,
        isAlumni: true
      }));
    }
  };

  const handleDropdownChange = (e) => {
    setErrorAddMentor(errorTemplate);
    const { name, value } = e.target;
    setAddMentor((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleUploadProfile = (e) => {
    const client = filestack.init("AASYllbvHQ3u0A1GxbOvZz");

        client.picker({
            accept: ['image/*'],
            onUploadDone: (result) => {
                if (result?.filesFailed?.length > 0) {
                    setIsShowError(true);
                    setErrMessage("Something went wrong")
                }
                if (result?.filesUploaded?.length > 0) {
                    console.log(result?.filesUploaded[0]?.url)
                    setAddMentor(prev => ({
                        ...prev,
                        profileImg: result?.filesUploaded[0]?.url
                    }));
                }
            },
        }).open();
  };

  const validate = () => {
    const filter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    for (const key in errorAddMentor) {
      // if((key === "interests" || key === "topics") && addMentor[key].length < 1) {
      //   setErrorAddMentor((prev) => ({
      //     ...prev,
      //     [key]: "This field is mandatory",
      //   }));
      //   return true;
      // }
      if ((key === "interests") && interests.length < 1) {
        setErrorAddMentor((prev) => ({
          ...prev,
          [key]: "This field is mandatory",
        }));
        return true;
      }
      if ((key === "topics") && topics.length < 1) {
        setErrorAddMentor((prev) => ({
          ...prev,
          [key]: "This field is mandatory",
        }));
        return true;
      }
      if ((key === "programs") && programs.length < 1) {
        setErrorAddMentor((prev) => ({
          ...prev,
          [key]: "This field is mandatory",
        }));
        return true;
      }
      if (key === "mobileNumber" && addMentor[key].length < 10) {
        setErrorAddMentor((prev) => ({
          ...prev,
          mobileNumber: "Please fill valid mobile number",
        }));
        return true;
      }
      if (key === "email" && !filter.test(addMentor["email"])) {
        setErrorAddMentor((prev) => ({
          ...prev,
          mobileNumber: "Please fill valid email",
        }));
        return true;
      }
      if (!addMentor[key]) {
        if (key === "lastName") continue;
        if (key === "programs") continue;
        setErrorAddMentor((prev) => ({
          ...prev,
          [key]: "This field is mandatory",
        }));
        return true;
      }
    }
  };
  const handleDiscard = () => {
    setAddMentor(template);
    setInterests([]);
    setTopics([]);
  };

  const handleSave = () => {
    if (!validate()) {
      const payload = addMentor;
      payload["profileImg"] = addMentor["profileImg"]["url"];
      payload["interests"] = interests.map((item) => item.value);
      payload["programs"] = programs.map(item => item.value);
      payload["topics"] = topics.map((item) => item.value);
      payload["languages"] = languages;
      const obj = {
        user: "mentor",
        obj: payload,
      };
      dispatch(addUser(obj));
    }
    else {
      setTimeout(() => {
        const ele = document.querySelector('.FormError');
        ele.parentElement.scrollIntoView({ behavior: 'smooth' })
      }, 10)
    }
  };

  const handleSuccessContinue = () => {
    setIsShowSuccess(false);
    navigate("/admin/all-mentor");
  };

  const handleGetInterests = (toggler) => {
    if (!toggler && programs?.length > 0) {
      const obj = {
        programs: programs.map(item => item.value)
      }
      dispatch(getInterestsByProgram(obj));
    }
  };

  useEffect(() => {
    dispatch(getAllPrograms());
  }, []);

  useEffect(() => {
    if (allPrograms?.length > 0) {
      setProgramOptions(allPrograms?.map(item => {
        return {
          label: item?.programName,
          value: item?.id
        }
      }));
    }
  }, [allPrograms])

  useEffect(() => {
    if (interestTopics && Object.keys(interestTopics)?.length > 0) {
      setTopicOptions(
        interestTopics?.topics?.map((item) => {
          return {
            label: item?.Topic,
            value: item?.id,
          };
        })
      );
      setInterestOptions(
        interestTopics?.interests?.map((item) => {
          return {
            label: item?.interest,
            value: item?.id,
          };
        })
      );
    }
  }, [interestTopics]);

  useEffect(() => {
    if (interests.length > 0 || topics.length > 0 || programs?.length > 0) setErrorAddMentor(errorTemplate);
  }, [interests, topics, programs])

  useEffect(() => {
    if (isUserAddedSuccess) {
      setIsShowSuccess(true);
      // setSuccessMessage("Success!")
      // setTimeout(() => {
      //   navigate("/admin/AllMentors");
      // },1000)
      dispatch(clearState());
    }
  }, [isUserAddedSuccess]);

  // useEffect(() => {
  //   if(proId) {
  //     setAddMentor(prev => ({
  //       ...prev,
  //       programId: proId
  //     }))
  //   }
  // },[proId]);

  // useEffect(() => {
  //   if (addMentor["programId"]) dispatch(getInterestsAndTopics(addMentor["programId"]));
  // }, [addMentor["programId"]])

  useEffect(() => {
    if (isError) {
      setAddMentor(template);
      setIsShowError(true);
      setErrMessage(errorMessage);
      dispatch(clearState());
    }
  }, [isError]);


  //dropdown
  const [Dropdownlist, setDropdownlist] = useState();

  return (
    <>
      {((isFetching || isLoading) || isProgramFetching) && <PageLoader />}
      <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
      <Congratulations
        maintext="Congratulations!"
        textpass="The mentor has successfully been added."
        dasbtn="Back to Dashboard"
        isActive={isShowSuccess}
        onClick={handleSuccessContinue}
      />
      <section className="allMentorWrapper">
        <div className="MymentorsHeading flex gap-10">
          <img
            src="/assets/img/BackArrow.png"
            alt=""
            className="pointer"
            onClick={() => navigate("/admin/all-mentor")}
          />
          <div className="headingwrap">
            <h2 className="heading-2 mb10">Add Mentor</h2>
            <p className="text2">Back to viewing all Mentors</p>
          </div>
        </div>

        <div className="addMentorWrapper mt-20 overflow">
          <div className="userProfileEdit mulipleFormInputWrap">
            <h4 className="lableHeading">Avatar</h4>
            <div className="leftWrapperPrfile mb25">
              <div className="userProfileEditTab">
                <label className="userProfile pointer" for="bgimg">
                  <img
                    src={
                      addMentor["profileImg"]
                        ? addMentor["profileImg"]
                        : "/assets/img/user1.png"
                    }
                    alt=""
                    className="userimg"
                    onClick={handleUploadProfile}
                  />
                  <img
                    src="/assets/img/edit.png"
                    alt=""
                    className="editimg pointer"
                  />
                </label>
              </div>
              <p className="mt-10 text2">
                {addMentor["profileImg"]["name"]
                  ? addMentor["profileImg"]["name"]
                  : "File types allowed are: jpg, jpeg, png"}
              </p>
            </div>
          </div>
          <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">
              Full Name<span className="impRed"> *</span>
            </h4>
            <div className="multipleFormInput flex-center">
              <InputField
                errorMessage={errorAddMentor["firstName"]}
                name={"firstName"}
                value={addMentor["firstName"]}
                onChange={handleChange}
                notImp={true}
                placeholder={"First Name"}
              />
              <InputField
                errorMessage={errorAddMentor["lastName"]}
                name={"lastName"}
                value={addMentor["lastName"]}
                onChange={handleChange}
                notImp={true}
                placeholder={"Last Name"}
              />
            </div>
          </div>

          <div className="mulipleFormInputWrap flexbox">
            <h4 className='lableHeading'>Program <span className="impRed"> *</span></h4>
            <div className="multipleFormInput flex-center">
              <div className='Dropdownseeting heightfixadd'>
                <MultiSelect
                  className='newWrapFull'
                  options={programOptions?.length > 0 ? programOptions : []}
                  value={programs}
                  onChange={setPrograms}
                  overrideStrings={{
                    selectSomeItems: "Select your Programs"
                  }}
                  onMenuToggle={(toggler) => handleGetInterests(toggler)}
                />
                {errorAddMentor["programs"] && <span className='FormError'>{errorAddMentor["programs"]}</span>}
              </div>
            </div>
          </div>

          <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">
              Email<span className="impRed"> *</span>
            </h4>
            <div className="multipleFormInput flex-center">
              <InputField
                errorMessage={errorAddMentor["email"]}
                name={"email"}
                value={addMentor["email"]}
                onChange={handleChange}
                notImp={true}
                placeholder={"Input email id"}
              />
            </div>
          </div>

          {/* <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">
              Program<span className="impRed"> *</span>
            </h4>
            <div className="multipleFormInput AdMentorDropdown">
            <Dorpwoncustom isActive={Dropdownlist} setIsActive={setDropdownlist} placeholder={'Select program'} options={options} />
            </div>
          </div> */}

          <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">Phone Number <span className="impRed"> *</span></h4>
            <div className="multipleFormInput flex-center">
              <InputField
                errorMessage={errorAddMentor["mobileNumber"]}
                type={"number"}
                name={"mobileNumber"}
                value={addMentor["mobileNumber"]}
                onChange={handleChange}
                notImp={true}
                placeholder={"Input contact number"}
                onKeyDown={(e) =>
                  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                }
              />
            </div>
          </div>

          <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">
              Designation
            </h4>
            <div className="multipleFormInput flex-center">
              <InputField
                errorMessage={errorAddMentor["designation"]}
                name={"designation"}
                value={addMentor["designation"]}
                onChange={handleChange}
                notImp={true}
                placeholder={"Input designation"}
              />
            </div>
          </div>

          <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">
              Current Company Name
            </h4>
            <div className="multipleFormInput flex-center">
              <InputField
                errorMessage={errorAddMentor["company"]}
                name={"company"}
                value={addMentor["company"]}
                onChange={handleChange}
                notImp={true}
                placeholder={"Input company name"}
              />
            </div>
          </div>

          <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">
              Linkedin Profile
              <span className="impRed"> *</span>
            </h4>
            <div className="multipleFormInput flex-center">
              <InputField
                errorMessage={errorAddMentor["linkedIn"]}
                name={"linkedIn"}
                value={addMentor["linkedIn"]}
                onChange={handleChange}
                notImp={true}
                placeholder={"Input linkedin profile link"}
              />
            </div>
          </div>

          <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">
              Functional Focus Area <span className="impRed"> *</span>
            </h4>
            <div className="multipleFormInput flex-center">
              <MultiSelect
                className="newWrapFull"
                options={interestOptions}
                value={interests}
                onChange={setInterests}
                labelledBy="Select your Professional Interests"
              />
              {errorAddMentor["interests"] && (
                <span className="FormError FormError w-100">{errorAddMentor["interests"]}</span>
              )}
            </div>
          </div>

          <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">
              Expertise <span className="impRed"> *</span>
            </h4>
            <div className="multipleFormInput flex-center">
              <MultiSelect
                className="newWrapFull"
                options={topicOptions}
                value={topics}
                onChange={setTopics}
                labelledBy="Select your topic of mentoring"
              />
              {errorAddMentor["topics"] && (
                <span className="FormError FormError w-100">{errorAddMentor["topics"]}</span>
              )}
            </div>
          </div>

          <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">Years of Experience </h4>
            <div className="multipleFormInput flex-center">
              <InputField
                errorMessage={errorAddMentor["yrsOfExp"]}
                type={"number"}
                name={"yrsOfExp"}
                value={addMentor["yrsOfExp"]}
                onChange={handleChange}
                notImp={true}
                placeholder={"0"}
                onKeyDown={(e) =>
                  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                }
              />
            </div>
          </div>

          <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">About Mentor</h4>
            <div className="multipleFormInput flex-center textareainput">
              <textarea
                placeholder="Input some details about Mentor to describe"
                onChange={handleChange}
                name="about"
                value={addMentor["about"]}
              ></textarea>
            </div>
          </div>

          <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">Fluent In</h4>
            <div className="multipleFormInput flex-center">
              <TagsInput
                value={languages}
                onChange={setLanguages}
                placeHolder="Enter languages you are fluent in"
              />
            </div>
          </div>

          <div className="mulipleFormInputWrap flexbox">
            <h4 className="lableHeading">is Alumni</h4>
            <div>
              <ToggleSwitch checked={addMentor?.isAlumni} onChange={handleCheckboxChange} />
            </div>
          </div>

          <div className="border-btm w-100"></div>
          <div className="FooterAddmentors flex flexend">
            <Button
              name={"Discard"}
              className={"buttontext GreyFillButton"}
              onClick={handleDiscard}
            />
            <Button
              name={"Save Changes"}
              className="active buttontext BlueFillButton"
              onClick={handleSave}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default AddMentor;
